export default __webpack_public_path__ + "static/xmasPop2-f4d7b60b3f6b3c609d37913ee491f8c4.png";